import React, { useMemo } from 'react'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { Row, Col } from 'antd'

import { ApplicationState } from 'src/store'
import { currencyMask } from 'src/components/Formik'
import { Text } from 'src/components/Ant'

import { R7HeaderTableGeneric } from './r7-header-table-generic'
import R7HeaderTableAgencies from './r7-header-table-agencies'
import { WrapSectionHeader } from './styles'

function TableSort(a: R7HeaderTableGeneric, b: R7HeaderTableGeneric): number {
  const total = b.total - a.total
  return total !== 0 ? total : `${a.name}` > `${b.name}` ? 1 : -1
}

function SectionHeader() {
  const {
    reports: {
      reportsResources: {
        R7Data: { data },
        R7Header: { data: header }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  const buildResumes = useMemo(() => {
    let AgenciesData: R7HeaderTableGeneric[] = []
    let totalSumValue = 0

    for (let register of data) {
      //agency
      const agencyIndex = AgenciesData.findIndex(
        //@ts-ignore
        item => item.name === register.agency_name
      )

      if (agencyIndex > -1) {
        AgenciesData[agencyIndex].total += register.tickets_total_sum
      } else {
        AgenciesData.push({
          name: register.agency_name,
          total: register.tickets_total_sum,
          percent: ''
        })
      }

      //total sum
      totalSumValue += register.tickets_total_sum
    }
    AgenciesData = AgenciesData.reduce(
      (acc, { name, total }) => [
        ...acc,
        {
          name,
          percent: ((total * 100) / totalSumValue).toFixed(1),
          total
        }
      ],
      []
    ).sort(TableSort)

    return {
      AgenciesData
    }
  }, [data])

  const { AgenciesData } = buildResumes

  if (!header.length) {
    return null
  }

  const defaultInfo = ' - '

  const total_request_count = header[0].total_request_count || defaultInfo
  const total_request_tickets_count =
    header[0].total_request_tickets_count || defaultInfo
  const startedOn =
    moment.unix(header[0].started_on).utc().format('DD/MM/YYYY') || defaultInfo
  const endedOn =
    moment.unix(header[0].ended_on).utc().format('DD/MM/YYYY') || defaultInfo
  const total_tickets_sum = (
    <Text>
      {
        currencyMask({
          formatStr: true,
          precision: 2,
          value: header[0].total_sum
        }).maskedValue
      }
    </Text>
  )
  return (
    <WrapSectionHeader>
      <Row>
        <Col span={7}>
          <Row>
            <Col span={24}>
              <Text colon id="header" title="web.report.7.header.started-on">
                <span id="value">{startedOn}</span>
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Text colon id="header" title="web.report.7.header.ended-on">
                <span id="value">{endedOn}</span>
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Text
                colon
                id="header"
                title="web.report.7.header.total-request-count"
              >
                <span id="value">{total_request_count}</span>
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Text
                colon
                id="header"
                title="web.report.7.header.total-request-tickets-count"
              >
                <span id="value">{total_request_tickets_count}</span>
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Text colon id="header" title="web.report.7.header.total-sum">
                <span id="value">{total_tickets_sum}</span>
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              {header[0].emitted && <Text title="web.report.6.emitted" />}
            </Col>
          </Row>
        </Col>
        <Col offset={8} span={8}>
          <R7HeaderTableAgencies dataSource={AgenciesData} />
        </Col>
      </Row>
    </WrapSectionHeader>
  )
}

export default SectionHeader
